import styled from 'styled-components';

export const ConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px 0 8px 0;
`;

export const ConfirmationMessage = styled.p`
  color: ${({ theme }) => theme.colors.grey600};
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  text-align: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: auto;
`;

export const ConfirmButton = styled.button`
  background-color: ${({ confirmButtonColor }) => confirmButtonColor};
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CancelButton = styled.button`
  background-color: #e5e5e5;
  color: ${({ theme }) => theme.colors.grey600};
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;
